import Swal from "sweetalert2";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "environments/environment";
import { AuthService } from "../auth.service";
import { SystemService } from "../system.service";
import { AlertService } from "../alert.service";

@Injectable()
export class UtilsModalsService {
  constructor(
    private router: Router,
    private systemService: SystemService,
    public alertService: AlertService
  ) {}

  showModalConfirmationDelete(id: number, name: string): Observable<boolean> {
    const translations =
      AuthService.getFromStorage(environment.storageLanguageNameApi) == "es"
        ? environment.modalsTranslatesEs
        : environment.modalsTranslatesEn;

    return new Observable<boolean>((observer) => {
      Swal.fire({
        title: translations.areYouSureDelete + " " + name + "?",
        text: translations.youWontBeAbleRevert,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-info",
        },
        confirmButtonText: translations.yes,
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          observer.next(true);
        } else {
          observer.next(false);
        }
      });
    });
  }

  showModalConfirmationOverwrite(
    id: number,
    name: string
  ): Observable<boolean> {
    const translations =
      AuthService.getFromStorage(environment.storageLanguageNameApi) == "es"
        ? environment.modalsTranslatesEs
        : environment.modalsTranslatesEn;

    return new Observable<boolean>((observer) => {
      Swal.fire({
        title: translations.areYouSureOverwrite + " " + name + "?",
        text: translations.youWontBeAbleRevert,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-info",
        },
        confirmButtonText: translations.yes,
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          observer.next(true);
        } else {
          observer.next(false);
        }
      });
    });
  }

  /* showModalDeleteSuccesfull(id: number) {
    Swal.fire({
      title: "Deleted " + id + "!",
      text: "Id " + id + " has been deleted.",
      icon: "success",
      customClass: {
        confirmButton: "btn btn-success",
      },
      buttonsStyling: false,
    });
  }

  showModalDeleteError(id: number) {
    Swal.fire({
      title: "Error",
      text: "Id " + id + " has not been deleted.",
      icon: "error",
      customClass: {
        confirmButton: "btn btn-error",
      },
      buttonsStyling: false,
    });
  }
 */
  showModalExpiredSession() {
    const translations =
      AuthService.getFromStorage(environment.storageLanguageNameApi) == "es"
        ? environment.modalsTranslatesEs
        : environment.modalsTranslatesEn;

    Swal.fire({
      title: translations.yourSessionHasExpired,
      text: "",
      icon: "warning",
      showCancelButton: false,
      customClass: {
        confirmButton: "btn btn-success",
      },
      confirmButtonText: translations.login,
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.router.navigateByUrl("/public");
      }
    });
    return false;
  }

  showModalErrorRedirect(error) {
    const translations =
      AuthService.getFromStorage(environment.storageLanguageNameApi) == "es"
        ? environment.modalsTranslatesEs
        : environment.modalsTranslatesEn;
    const statusCode = error?.statusCode ?? "";
    const message = error?.msg ?? translations.error;

    Swal.fire({
      title: translations.error + " " + statusCode,
      text: message,
      icon: "error",
      customClass: {
        confirmButton: "btn btn-error",
      },
      buttonsStyling: false,
    }).then((result) => {
      let typeUser: string = AuthService.getFromStorage(
        environment.storageTypeUserNameApi
      );

      // 403 -> Expired token
      // 401 -> Unautorized
      if (statusCode == 403 || statusCode == 401) {
        this.router.navigateByUrl("/public/login");
      }
    });
    return false;
  }

  showModalTimeoutRedirect(error, request) {
    const translations =
      AuthService.getFromStorage(environment.storageLanguageNameApi) == "es"
        ? environment.modalsTranslatesEs
        : environment.modalsTranslatesEn;
    Swal.fire({
      title: translations.error + " " + 504,
      text: translations.timeoutHasOccurred,
      icon: "error",
      customClass: {
        confirmButton: "btn btn-error",
      },
      confirmButtonText: translations.login,
      buttonsStyling: false,
    }).then((result) => {
      this.sendSystemReport(error, request);
      this.router.navigateByUrl("/public/login");
    });

    return false;
  }

  showModalRecoveryPasswordSuccess() {
    const translations =
      AuthService.getFromStorage(environment.storageLanguageNameApi) == "es"
        ? environment.modalsTranslatesEs
        : environment.modalsTranslatesEn;

    Swal.fire({
      title: translations.passwordChanged,
      text: translations.youPasswordHaveBeenChanged,
      icon: "info",
      customClass: {
        confirmButton: "btn btn-error",
      },
      confirmButtonText: translations.login,
      buttonsStyling: false,
    }).then((result) => {
      this.router.navigateByUrl("/public/login");
    });
    return false;
  }

  showModalRecoveryPasswordError() {
    const translations =
      AuthService.getFromStorage(environment.storageLanguageNameApi) == "es"
        ? environment.modalsTranslatesEs
        : environment.modalsTranslatesEn;

    Swal.fire({
      title: translations.passwordChanged,
      text: translations.error,
      icon: "error",
      customClass: {
        confirmButton: "btn btn-error",
      },
      confirmButtonText: translations.login,
      buttonsStyling: false,
    }).then((result) => {
      this.router.navigateByUrl("/public/login");
    });
    return false;
  }

  //Send System Report
  sendSystemReport(msg: string, request) {
    msg =
      msg +
      "<br/><br/>" +
      "IdUser: " +
      AuthService.getFromStorage(environment.storageIdUserNameApi) +
      "<br/>" +
      "Username: " +
      AuthService.getFromStorage(environment.storageUsernameNameApi) +
      "<br/>" +
      "Type User: " +
      AuthService.getFromStorage(environment.storageTypeUserNameApi) +
      "<br/>" +
      "URL: " +
      request.url +
      "<br/>" +
      "Method: " +
      request.method +
      "<br/>" +
      "Body params: " +
      JSON.stringify(request.body);
    this.systemService.sendMailToAdmin(msg).subscribe({
      next: (response) => {},
      error: (e) => {
        this.alertService.error("error send mail", { autoClose: true });
      },
      complete: () => {},
    });
  }
}
